var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("改单记录")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.show3,
                expression: "!show3",
              },
            ],
            staticClass: "inquiry",
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("span", [_vm._v("数据查询")]),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.show3,
                      expression: "!show3",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.show3 = true
                    },
                  },
                },
                [_vm._v("收起")]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.show3,
                      expression: "show3",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.show3 = false
                    },
                  },
                },
                [_vm._v("展开")]
              ),
            ]),
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  inline: true,
                  model: _vm.queryForm,
                  "label-width": "",
                  size: "mini",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "信息" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入客户手机号码/姓名" },
                      model: {
                        value: _vm.queryForm.info,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "info", $$v)
                        },
                        expression: "queryForm.info",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单编号" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入订单编号" },
                      model: {
                        value: _vm.queryForm.identifier,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "identifier", $$v)
                        },
                        expression: "queryForm.identifier",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "部门选择" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.options,
                        props: {
                          checkStrictly: true,
                          label: "orgName",
                          value: "orgCode",
                          children: "children",
                        },
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.queryForm.orgName,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "orgName", $$v)
                        },
                        expression: "queryForm.orgName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "客服" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "请选择客服",
                          "default-first-option": "",
                        },
                        model: {
                          value: _vm.queryForm.service,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "service", $$v)
                          },
                          expression: "queryForm.service",
                        },
                      },
                      _vm._l(_vm.customer, function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: { label: items.reallyName, value: items.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单状态" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "选择订单状态",
                          "default-first-option": "",
                        },
                        model: {
                          value: _vm.queryForm.state,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "state", $$v)
                          },
                          expression: "queryForm.state",
                        },
                      },
                      _vm._l(_vm.status, function (itemsS) {
                        return _c("el-option", {
                          key: itemsS.dictId,
                          attrs: {
                            label: itemsS.dictName,
                            value: itemsS.dictId,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "selectDate" }, [
                  _c("span", [_vm._v("时间")]),
                  _c(
                    "div",
                    { staticClass: "picker" },
                    [
                      _c(
                        "el-date-picker",
                        {
                          attrs: {
                            type: "daterange",
                            "unlink-panels": "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            format: "yyyy- MM- dd",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.date,
                            callback: function ($$v) {
                              _vm.date = $$v
                            },
                            expression: "date",
                          },
                        },
                        [_vm._v("> ")]
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "地区" } },
                  [
                    _c("levelAddr", {
                      staticClass: "addressContent",
                      attrs: {
                        province: _vm.queryForm.province,
                        city: _vm.queryForm.city,
                        area: _vm.queryForm.area,
                      },
                      on: {
                        updateprovice: _vm.getProvince,
                        updatecity: _vm.getCity,
                        updatearea: _vm.getArea,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.searchEvent()
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchEvent.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      { attrs: { plain: "" }, on: { click: _vm.reset } },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "btns", staticStyle: { margin: "10px" } },
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "danger", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.xTable.setAllRowExpand(true)
                    },
                  },
                },
                [_vm._v("展示")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "warning", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.xTable.clearRowExpand()
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
          _vm.show3
            ? _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.show3 = false
                    },
                  },
                },
                [_vm._v("搜索展开")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "vxe-table",
            {
              ref: "xTable",
              staticClass: "tableCont",
              attrs: {
                data: _vm.tableData.list,
                "expand-config": { expandAll: true },
                "sort-config": { trigger: "cell" },
                align: "center",
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "seq", title: "序号", width: "50" },
              }),
              _c("vxe-table-column", {
                attrs: { type: "expand", width: "55" },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.toDetail(row)
                              },
                            },
                          },
                          [
                            _c(
                              "el-form",
                              { staticClass: "demo-table-expand" },
                              [
                                _c(
                                  "el-form-item",
                                  _vm._l(
                                    row.orderCommodityList,
                                    function (items) {
                                      return _c("p", { key: items.id }, [
                                        _c("span", [
                                          _vm._v(_vm._s(items.name)),
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(items.price) +
                                              " × " +
                                              _vm._s(items.number) +
                                              " = " +
                                              _vm._s(items.total) +
                                              " 元"
                                          ),
                                        ]),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                                !_vm.is_null(row.orderComplimentaryList)
                                  ? _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [_vm._v("附属品：")]
                                        ),
                                        _vm._l(
                                          row.orderComplimentaryList,
                                          function (items) {
                                            return _c(
                                              "p",
                                              {
                                                key: items.id,
                                                staticClass: "complimentary",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      items.complimentaryName
                                                    )
                                                  ),
                                                ]),
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(items.price) +
                                                      " × " +
                                                      _vm._s(items.number) +
                                                      " = " +
                                                      _vm._s(items.total) +
                                                      " 元"
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "订单编号", field: "orderUser.orderIdStr" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "下单时间", field: "orderUser.createdTime" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "客户",
                  field: "orderUser.addressName",
                  width: "150",
                },
              }),
              _c("vxe-table-column", {
                attrs: { title: "订单状态", field: "orderUser.orderType" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "总计",
                  field: "orderUser.total",
                  width: "100",
                },
              }),
              _c("vxe-table-column", {
                attrs: { title: "备注", "show-overflow": "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm.is_null(props.row.orderUser.comment)
                          ? _c("span", [_vm._v("--")])
                          : _vm._e(),
                        !_vm.is_null(props.row.orderUser.comment)
                          ? _c("span", [
                              _vm._v(_vm._s(props.row.orderUser.comment)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticClass: "btn" }, [
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.toDetail(props.row)
                                },
                              },
                            },
                            [_vm._v("详情")]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.tableData.totalNum > 0
            ? _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage1,
                        "page-sizes": [10, 20, 50, 100, 200],
                        "page-size": _vm.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.tableData.totalNum,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }